module.exports = __webpack_public_path__ + "static/img/shoonya_logo_full.a990668.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/shoonya_logo_full.webp
// module id = snSy
// module chunks = 7